import { Pane, Heading, Text, Badge, Avatar, TrashIcon } from 'evergreen-ui';

export default function TurniSidebar({
  collaboratorsList,
  getInitials,
  isDirector,
  viewMode,
  isDragOverTrash,
  setIsDragOverTrash,
  onTrashDrop,
  onDragStart,
}) {
  return (
    <Pane width="100%" background="white" padding={16} borderRadius={8} border="default">
      <Heading size={500} marginBottom={16}>Collaboratori</Heading>
      <Pane display="flex" flexDirection="column" gap={8} marginBottom={32}>
        {(collaboratorsList || []).map(u => {
          const uName = `${u.nome} ${u.cognome}`.trim();
          return (
            <Pane
              key={u.id}
              padding={8} background="tint2" borderRadius={4}
              draggable={isDirector}
              onDragStart={(e) => onDragStart(e, uName)}
              cursor={isDirector ? 'grab' : 'default'}
              display="flex" alignItems="center" gap={8}
            >
              <Avatar name={getInitials(uName)} size={24} />
              <Text>{uName}</Text>
            </Pane>
          );
        })}
      </Pane>

      {isDirector && viewMode === 'mensile' && (
        <Pane
          marginBottom={24} padding={12} borderRadius={8}
          border={isDragOverTrash ? '2px solid #D14343' : '2px dashed #c1c4d6'}
          background={isDragOverTrash ? '#FFEAEA' : 'tint1'}
          display="flex" flexDirection="column" alignItems="center" justifyContent="center"
          gap={8} minHeight={72}
          onDragOver={(e) => { e.preventDefault(); setIsDragOverTrash(true); }}
          onDragLeave={() => setIsDragOverTrash(false)}
          onDrop={onTrashDrop}
        >
          <TrashIcon color={isDragOverTrash ? 'danger' : 'muted'} size={20} />
          <Text size={300} color={isDragOverTrash ? 'danger' : 'muted'}>
            {isDragOverTrash ? 'Rilascia per eliminare / rifiutare' : 'Trascina turni o assenze per eliminarle'}
          </Text>
        </Pane>
      )}

      <Heading size={500} marginBottom={16}>Legenda</Heading>
      <Pane display="flex" flexDirection="column" gap={8}>
        <Badge color="orange" isSolid>Coda della notte</Badge>
        <Badge color="blue" isSolid>Giorno</Badge>
        <Badge color="neutral" isSolid style={{ backgroundColor: '#1a1a1a', color: '#fff' }}>Notte</Badge>
        {isDirector ? (
          <>
            <Badge color="green" isSolid>F - Ferie</Badge>
            <Badge color="yellow" isSolid>P - Permesso</Badge>
            <Badge color="red" isSolid>M - Malattia</Badge>
          </>
        ) : (
          <Badge color="neutral" isSolid>ASS - Assente</Badge>
        )}
      </Pane>
    </Pane>
  );
}
